import { useContext } from 'react'

import CheckoutDataContext from './CheckoutDataContext'

const useCheckoutData = () => useContext(CheckoutDataContext)

export default useCheckoutData
